import React, { Fragment, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import {
  BETS_NAMES_BY_GROUP_TYPES,
  BETS_NAMES_BY_MARKET_TYPE,
  BOARD_CARD_GROUP_TYPES,
  ROUND_PHASE_TYPES_NAMES,
} from '../../../enums/betTypesEnum';

export const CurrentUserBet = observer(({ phaseName, betData }) => {
  const [isShowBets, setIsShowBets] = useState(false);
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();
  return (
    <div
      className={`my-bets ${isShowBets ? 'open' : ''} ${betData?.length ? '' : 'disabled'}`}
      onClick={() => (betData?.length ? setIsShowBets((prev) => !prev) : null)}
    >
      <div className='my-b-value'>
        <p>
          {t(ROUND_PHASE_TYPES_NAMES[phaseName])}{' '}
          <span>{betData?.length ? `(${betData?.length})` : null}</span>
        </p>
        <i className='icon-arrow-down1' />
      </div>
      {isShowBets && (
        <div className='open-bets-section'>
          {betData &&
            betData?.map((item, index) => (
              <Fragment key={`${item.marketType}`.concat(`${index}`)}>
                <div className='bet-box-value'>
                  {BOARD_CARD_GROUP_TYPES.includes(item.groupType) ? (
                    <span>
                      {t(BETS_NAMES_BY_GROUP_TYPES[item.groupType])}{' '}
                      {t(BETS_NAMES_BY_MARKET_TYPE[item.marketType])}
                    </span>
                  ) : (
                    <span>{t(BETS_NAMES_BY_MARKET_TYPE[item.marketType])}</span>
                  )}
                  <span>
                    {t('ODD')} x{item.odd}
                  </span>
                </div>
                <div className='bet-box-value'>
                  <span>
                    {t('BET')} {item.amount} {currencySymbolOrCode}
                  </span>
                  {!!item.winAmount && (
                    <span className='yellow'>
                      {t('WIN')} {item.winAmount} {currencySymbolOrCode}
                    </span>
                  )}
                </div>
              </Fragment>
            ))}
        </div>
      )}
    </div>
  );
});
